import type { ReactNode } from "react";
import { Icon } from "./Icon";

export function EvidenceRow({ children, tone = "evidence", onClick }: { children: ReactNode; tone?: "evidence" | "uncertain" | "conflict"; onClick?: () => void }) {
  const inner = (
    <>
      <Icon name={tone === "evidence" ? "check" : "alert"} size={23} />
      <span>{children}</span>
      {onClick ? <Icon name="chevron" size={20} className="evidence-row__chevron" /> : null}
    </>
  );
  return onClick ? (
    <button type="button" className={`evidence-row evidence-row--${tone}`} onClick={onClick}>{inner}</button>
  ) : (
    <div className={`evidence-row evidence-row--${tone}`}>{inner}</div>
  );
}
